import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// calling setInterval every second
const REFRESH_INTERVAL_SCALE = 1000;
let timeoutStart = new Date().getTime() / 1000;
const getCurrentSeconds = () => new Date().getTime() / 1000;

export const CountDown = ({ duration, onEnd }) => {
  const [remainingTime, setRemainingTime] = useState(duration);
  const [startTime, setStartTime] = useState(null);

  useEffect(() => {
    // in mount stage saving time mark for beginning of countdown
    const now = getCurrentSeconds();
    timeoutStart = now;
    setStartTime(now);
    // Reset to exact duration on mount
    setRemainingTime(duration);
  }, [duration]);

  useEffect(() => {
    if (startTime === null) return;

    const countdown = setInterval(() => {
      // getting current time and calculating elapsed time
      const elapsed = getCurrentSeconds() - startTime;
      const remaining = duration - elapsed;

      // Use Math.floor to avoid showing 01:02 at the start
      const secondsRemaining = Math.floor(remaining);

      if (secondsRemaining >= 0) {
        setRemainingTime(secondsRemaining);
      }

      if (secondsRemaining <= 0) {
        onEnd();
        clearInterval(countdown);
      }
    }, REFRESH_INTERVAL_SCALE);

    return () => clearInterval(countdown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, duration]);

  const formatTime = (time) => {
    const minutes = parseInt(time / 60, 10);
    const seconds = parseInt(time % 60, 10);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return <span className='timer'>{formatTime(Math.abs(remainingTime))}</span>;
};

CountDown.propTypes = {
  duration: PropTypes.number.isRequired,
  onEnd: PropTypes.func.isRequired
};
